import { RiMenuLine, RiCloseFill } from "react-icons/ri";
const ButtonMovil = ({ sidebar, handleSidebar }) => {
  return (
    <button
      onClick={handleSidebar}
      className="clock lg:hidden fixed top-4 right-4 bg-green-600 p-2 text-white rounded-full text-2xl z-40"
    >
      {sidebar ? <RiCloseFill /> : <RiMenuLine />}
    </button>
  );
};
export default ButtonMovil;